import {
  CREATE_ATTENDANCE_FAILED,
  CREATE_ATTENDANCE_REQ,
  CREATE_ATTENDANCE_RESET,
  CREATE_ATTENDANCE_SUCCESS,
  GET_ATTENDANCE_FAILED,
  GET_ATTENDANCE_REQ,
  GET_ATTENDANCE_SUCCESS,
  JOIN_CLASS_FAILED,
  JOIN_CLASS_REQ,
  JOIN_CLASS_RESET,
  JOIN_CLASS_SUCCESS,
} from "../Constant/AttendanceConstatnt";

export const AttendanceRecordsListReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ATTENDANCE_REQ: {
      return { loading: true };
    }

    case GET_ATTENDANCE_SUCCESS: {
      return { loading: false, AttendanceRecs: payload };
    }
    case GET_ATTENDANCE_FAILED: {
      return { loading: false, error: payload };
    }

    default:
      return state;
  }
};

export const AttendanceMarkedReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case CREATE_ATTENDANCE_REQ: {
      return { loaidng: true };
    }

    case CREATE_ATTENDANCE_SUCCESS: {
      return { loading: false, success: payload };
    }

    case CREATE_ATTENDANCE_FAILED: {
      return { loading: false, error: payload };
    }

    case CREATE_ATTENDANCE_RESET: {
      return { loading: false, error: "" };
    }

    default:
      return state;
  }
};

export const JoinClassReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case JOIN_CLASS_REQ: {
      return { loading: true };
    }

    case JOIN_CLASS_SUCCESS: {
      return { loading: false, Class_Link_Url: payload };
    }
    case JOIN_CLASS_FAILED: {
      return { loading: false, error: payload };
    }
    case JOIN_CLASS_RESET: {
      return { loading: false, error: "" };
    }
    default:
      return state;
  }
};
